import { Dialog, TextField } from "@mui/material";
import { useState, useMemo } from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DialogContentFiltroTipoBaixa from "./DialogContentFiltroTipoBaixa";


export type TTipoBaixaFiltros = {
    filiais: "S" | "N";
    normal: "S" | "N";
    extraCaixa: "S" | "N";
    devolucao: "S" | "N";
    cancelamento: "S" | "N";
    substituicao: "S" | "N";
    manual: "S" | "N";
}

export default function FiltroTipoBaixa({
    value,
    required = false,
    error = false,
    errorMessage = undefined,
    label = 'Tipo de Baixa',
    disabled = false,
    onChange
}: FiltroTipoBaixaProps) {

    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    const inputLabel = useMemo(() => {
        if (!value) return "";

        const filtrosAtivos = Object.entries(value)
            .filter(([_, valor]) => valor === "S")
            .map(([key, _]) => {
                const labels = {
                    filiais: "Filiais",
                    normal: "Normal",
                    manual: "Manual",
                    extraCaixa: "Extra-Caixa",
                    devolucao: "Devolução",
                    cancelamento: "Cancelamento",
                    substituicao: "Substituição"
                };
                return labels[key as keyof typeof labels];
            });

        return filtrosAtivos.length > 0 ? filtrosAtivos.join(", ") : "Nenhum selecionado";
    }, [value]);

    const defaultValue: TTipoBaixaFiltros = {
        filiais: "N",
        normal: "N",
        extraCaixa: "N",
        devolucao: "N",
        cancelamento: "N",
        substituicao: "N",
        manual: "N"
    };

    return (
        <>
            <TextField
                disabled={disabled}
                {...{ required, error }}
                label={label}
                variant="outlined"
                fullWidth
                onClick={() => { if (!disabled) setOpenModal(true) }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: {
                        readOnly: true,
                        endAdornment: <KeyboardArrowDownIcon />
                    },
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {openModal && (
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentFiltroTipoBaixa
                        handleClose={handleClose}
                        defaultValue={value || defaultValue}
                        onChange={(newValue) => {
                            onChange(newValue);
                            handleClose();
                        }}
                    />
                </Dialog>
            )}
        </>
    );
}

interface FiltroTipoBaixaProps {
    disabled?: boolean;
    value: TTipoBaixaFiltros | null;
    onChange: (arg: TTipoBaixaFiltros) => void;
    required?: boolean;
    error?: boolean;
    errorMessage?: string | undefined;
    label?: string;
}